import bowser from 'bowser'

const initialState = bowser._detect(window.navigator.userAgent)

export default function(state = initialState, action) {
  return state
}
